import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { UmssLabelComponent } from '../label/label.component';

@Component({
  selector: 'umss-horizontal-field',
  standalone: true,
  imports: [CommonModule, UmssLabelComponent],
  templateUrl: './horizontal-field.component.html',
  styleUrls: ['./horizontal-field.component.scss']
})
export class UmssHorizontalFieldComponent {
  @HostBinding('style.display') display = 'contents';

  /** Content props */
  @Input() label: string = 'Label';
  @Input() htmlFor?: string;

  /** Label width */
  @Input() labelWidth: string = '120px';

  /** State props */
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() error: boolean = false;
}
